import React from "react";

export const LoadingSpinner: React.FC<{ label?: string }> = ({ label }) => (
  <div className="flex items-center gap-3 text-secondary-500" role="status">
    <span
      className="inline-block h-5 w-5 border-2 border-secondary-300 border-t-primary-500 rounded-full animate-spin"
      aria-hidden="true"
    />
    {label && <span className="text-sm">{label}</span>}
  </div>
);

export default LoadingSpinner;
